import type { Id } from '@e-socna/data-layer';
import { ThirdPartyTypeEnum, graphql } from '@e-socna/data-layer';

import { ThirdPartyFormTab } from '../../enums/tab.enum';

import { ThirdPartiesSelectionFormStep } from '../Selection';

import { useInitialGridState } from './hooks/useInitialGridState.hook';

export const ThirdPartyForm_MotherOrganizationStep_Organization_Fragment =
  graphql(`
    fragment ThirdPartyForm_MotherOrganizationStep_Organization_Fragment on Organization {
      motherId
    }
  `);

interface Props {
  readonly organizationId?: Id;
  readonly id: string;
  readonly isInternal: boolean;
}

export const ThirdPartyMotherOrganizationFormStep = ({
  organizationId,
  isInternal,
}: Readonly<Props>) => {
  const { initialGridState } = useInitialGridState();

  return (
    <ThirdPartiesSelectionFormStep
      excludedIds={organizationId ? [organizationId] : undefined}
      fieldName="motherId"
      id={ThirdPartyFormTab.MotherOrganization}
      initialGridState={initialGridState}
      isInternal={isInternal}
      kind={ThirdPartyTypeEnum.Organization}
    />
  );
};
